<app-navbar></app-navbar>
<div  class="card" style="padding: 20px; background-image: url('assets/img/school/bg.png');
 background-color: #005a63; background-size: 100px; background-attachment: fixed;">
 <h2 style=" text-align: center; margin-bottom: 10px;">Photos</h2>
 <br ><br >
 <div class="container" style="text-align: justify !important;">
  <div class="row">
    <div  class="col-md-12">
      <div class="card">
        <div  class="card-body text-justify">
          <ng-container *ngFor="let album of ImageAlbums">
          <div  class="folder mb-3">
            <a [routerLink]="['/imageFolder', album.Id]">
              <i  aria-hidden="true" class="fa fa-folder">

              </i>
              <p >{{album.Name}}</p>
            </a>
          </div>
        </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

